import React from "react"; 
import { gql, 
    useMutation 
} from "@apollo/client"; 
import { GetCbmMutationMutation, GetCbmMutationMutationVariables } from "../../../../schemaTypes";

export const GET_CBM_MUTATION = gql` 
    mutation GetCbmMutation(
        $memberId: String!
        ) { 
            getCBM(
                memberId: $memberId
            ) { 
                errors { path message } 
                message 
                } 
            } `; 
            
export interface WithGetCBM { 
    getCBM: ( 
        variables: GetCbmMutationMutationVariables
    ) => Promise<{ 
        errors: Record<string, string> | null; 
        message?: string | null; 
        supportMeta?: { 
            code?: string; 
            supportRef?: string; 
        }; }>; 
    } 
    
function normalizeErrors( 
    errors: { 
        path: string; 
        message: string 
    }[] | null | undefined ): Record<string, string> | null { 
        if (!errors || errors.length === 0) { 
            return null; 
        } const errMap: Record<string, string> = {}; 
        
        errors.forEach((error) => { 
            if (error && error.path) { 
                errMap[error.path] = error.message; 
            } 
        }); 
        return errMap; 
    } 
    
export function useGetCBM(): WithGetCBM { 
const [mutate] = useMutation< GetCbmMutationMutation, GetCbmMutationMutationVariables >(GET_CBM_MUTATION); 
const getCBM = React.useCallback( 
    async (variables: GetCbmMutationMutationVariables) => { 
        try { 
            const response = await mutate({ variables, }); 
            const result = response?.data?.getCBM; 
            
            if (!result) { 
                return { 
                    errors: { 
                        general: "No response from server.", }, 
                        message: undefined, supportMeta: undefined, 
                    }; 
                } 
                
                const errors = normalizeErrors(result.errors); 
                const message = result.message; 
                
                return { errors, message, supportMeta: undefined, }; 
            } catch (err) { 
                const maybeApolloErr = err as { message?: string; graphQLErrors?: Array<{ message?: string; extensions?: { code?: string; supportRef?: string; }; 
            }>; }; 
            
            const firstGraphQLError = maybeApolloErr.graphQLErrors?.[0]; const supportRef = firstGraphQLError?.extensions?.supportRef; 
            const code = firstGraphQLError?.extensions?.code; 
            const message = firstGraphQLError?.message || maybeApolloErr.message || "Something went wrong while fetching CBM information."; 
            
            return { 
                errors: { 
                    general: message, 
                }, 
                message: undefined, 
                supportMeta: { 
                    ...(typeof code === "string" ? { code } : {}), 
                    ...(typeof supportRef === "string" ? { supportRef } : {}), 
                }, 
            }; 
        } }, 
        [mutate] ); 
    return { getCBM, }; 
}